module.exports = [{
      plugin: require('/Users/devanfarrell/GitHub/devan.us/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
